import { element } from "svelte/internal";
import { ISystemContext } from "../../../Context/SystemContext";
import { CreateElement, Log, Rect, Scale, Size } from "../../../MyHelpers";
import { DecodedImageResource, ImageResource } from "../../../ResourceManager/ImageResource";
import { Resourceful } from "../../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { Translator } from "../../../Translator";
import { ZIndex } from "../../../ZIndex";
import { MyCanvas } from "../../MyCanvas";
import { S2_SpinnableReels2 } from "../../SpinAnimation2/SpinnableReels";
import { TweenLite } from "gsap";
//import { IFeatureConfiguration } from "../BigSymbolFreegames/BigSymbolFreegamesConfig";
import { JackpotDisplayType, Settings } from "../../../Settings";
import { AudioManager, Track } from "../../../AudioManager";
import { TweenMax, Power3 } from "gsap";
import { S2_SpinnableReelsBigCanvas2 } from "../../SpinAnimation2/SpinnableReelsBigCanvas2";
import { IFeatureConfiguration, UnlockRowsConfig } from "../../../api";
import { IUnlockFeatureParams, UnlockRowsResult, UnlockRowsStartConfig } from "./UnlockFeature";
import * as PIXI from 'pixi.js';
import { PixiSpriteResource } from "../../../ResourceManager/PixiSpriteResource";
import gsap from "gsap";
import * as plugin from "gsap/all";
import { SymbolCollection, SymbolsCollectionResources } from "../../SpineSymbols/SymbolsCollection";
import { assertEqual, assertNotMore } from "../../../debug";
gsap.registerPlugin(plugin.PixiPlugin);


export class UnlockFeaturePIXIAPP implements Resourceful {
    //protected view: HTMLElement;
    protected resid: ResourceIdentifier;
    protected translator: Translator;
    protected systemContext: ISystemContext;
    //protected rowUnlockview: HTMLElement[] = [];
    protected InfoCanvas: MyCanvas[] = [];
    protected sraUnlockMissingCanvas: MyCanvas[] = [];
    //protected sizeCanvas : Size[]= [ new Size (Scale.W(200),Scale.H(200)), new Size (Scale.W(950),Scale.H(200))]
    protected fontHeight: number[] = [Scale.fh(100), Scale.fh(70)];
    protected gameBonusResourcesBasePath: string;
    protected commonBonusResourcesBasePath: string;

    protected config: UnlockRowsConfig;
    protected fontHeightSra:number;
    protected fontHeightInfo:number = Scale.fh(50);
    protected audio: AudioManager;
    protected viewPIXIAPP: PIXI.Container = null;
    protected gameName : string = null;
    protected symbolsCollection : SymbolCollection;
    protected aspectFixY: number = 1;
 
    constructor(params: IUnlockFeatureParams, config: Record<string, UnlockRowsConfig>, symbolsCollection : SymbolCollection) {


        this.resid = params.resid.Add("UnclokFeature");
        this.translator = params.translator;
        this.systemContext = params.systemContext;
        this.commonBonusResourcesBasePath = params.commonBonusResourcesBasePath;
        this.gameBonusResourcesBasePath = params.gameBonusResourcesBasePath;
        this.audio = params.audio;
        this.gameName = params.gameName;
        this.aspectFixY = params.aspectFixY;

       
      

        //this.view.innerText = "LOCKED";
        // this.viewPIXIAPP = new PIXI.Container();
        // this.viewPIXIAPP.name = "unclockFeaturePIXIAPP";
        // this.viewPIXIAPP.width = this.windowRectangle.width;
        // this.viewPIXIAPP.height = this.windowRectangle.height;
        // this.viewPIXIAPP.x = this.windowRectangle.x;
        // this.viewPIXIAPP.y = this.windowRectangle.y;
        this.symbolsCollection  = symbolsCollection;
        const configList = Object.values(config);
        assertEqual(1, configList.length, `Expect 1 config, got ${configList.length}`);
        this.config = configList[0];

        
    }

    protected textInfoCanvasPIXIAPP: PIXI.Text[] = [];
    protected sraUnlockTextPIXIAPP: PIXI.Text[] = [];
    protected rowUnlockviewPIXIAPP : PIXI.Container [] = [];
    //sraUnlockMissingCanvas

    protected sraLockTexturePIXIAPP: PIXI.Texture<PIXI.Resource> = null;
    protected sraTriggerTexturePIXIAPP: PIXI.Texture<PIXI.Resource> = null;
    protected unlockFeatureFrameTexturePIXIAPP: PIXI.Texture<PIXI.Resource> = null;
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {


        let sraLockDecodedImageResources = resourceManager.Get<DecodedImageResource>(ResourceIdentifier.Global.ScopedResourceName("sraLock"));
        this.sraLockTexturePIXIAPP = PIXI.Texture.from(sraLockDecodedImageResources.DecodedImage());

        //use the base game texture symbol SRA 
         
        //let spriteSymbolPIXI = resourceManager.Get<PixiSpriteResource>(`ScreenAll-Multigame-${this.gameName}-Symbol-SRA`).sprite;           
        this.sraTriggerTexturePIXIAPP = PIXI.Texture.from(this.symbolsCollection.symbolCollectionMap.get("Symbol_SRA").imgResource);
        
        //let img = new PIXI.ImageResource(this.symbolsCollectionMap.get("Symbol_SRA").imgResource);        
        

        //use the base game texture symbol SRA 
        let unlockFeatureFrame = resourceManager.Get<DecodedImageResource>(ResourceIdentifier.Global.ScopedResourceName(`UnlockFeatureFrame`));
        this.unlockFeatureFrameTexturePIXIAPP = PIXI.Texture.from(unlockFeatureFrame.DecodedImage());


      
        // for (let rowIndex = 0; rowIndex < this.config.Rows.length; rowIndex++) {
        //     let rowConfig = this.config.Rows[rowIndex];
        //     let leftSymbol = this.spinnableReels2.GetSymbolRect(0, rowIndex);
        //     let totalWidth = this.spinnableReels2.GetWindowSize().width;

        //     //rowUnlockviewPIXIAPP main container 
        //     let rowUnlockviewPIXIAPP : PIXI.Container = new PIXI.Container();
        //     rowUnlockviewPIXIAPP.width = this.windowRectangle.width;
        //     rowUnlockviewPIXIAPP.height = leftSymbol.height;
        //     rowUnlockviewPIXIAPP.y = leftSymbol.height * rowIndex;
        //     rowUnlockviewPIXIAPP.name = `unclokRow-${rowIndex}`;            
        //     this.viewPIXIAPP.addChild(rowUnlockviewPIXIAPP);
        //     this.rowUnlockviewPIXIAPP.push(rowUnlockviewPIXIAPP);
            
        //     //texture black for alphanel main container
        //     // let rowUnlockviewPIXIAPPTEXTURE : PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        //     // rowUnlockviewPIXIAPPTEXTURE.width = this.windowRectangle.width ;
        //     // rowUnlockviewPIXIAPPTEXTURE.height = leftSymbol.height;
        //     // rowUnlockviewPIXIAPP.addChild(rowUnlockviewPIXIAPPTEXTURE);            
        //     // rowUnlockviewPIXIAPPTEXTURE.tint = 0x000000;
        //     // rowUnlockviewPIXIAPPTEXTURE.alpha = 0.8;


        //     let unlockFeatureFrameSprite = new PIXI.NineSlicePlane(unlockFeatureFrameTexturePIXIAPP,1,1,1,1);            
        //     unlockFeatureFrameSprite.name = "unlockFeatureFrameSprite";
        //     unlockFeatureFrameSprite.width = this.windowRectangle.width;
        //     unlockFeatureFrameSprite.height = leftSymbol.height;
        //     rowUnlockviewPIXIAPP.addChild(unlockFeatureFrameSprite);


        //     let unclockContainer : PIXI.Container = new PIXI.Container();
        //     unclockContainer.name = "unclockContainer"
        //     unclockContainer.position.set(Scale.W(180),Scale.W(169));
        //     unclockContainer.scale.set(Scale.XY(0.8));
        //     rowUnlockviewPIXIAPP.addChild(unclockContainer);

        //     let sraLockSpritePIXIAPP : PIXI.Sprite = new PIXI.Sprite(sraLockTexturePIXIAPP);     
        //     sraLockSpritePIXIAPP.anchor.set(0.5); 
        //     sraLockSpritePIXIAPP.scale.set(Scale.XY(1));      
        //     unclockContainer.addChild(sraLockSpritePIXIAPP);

        //     //Create Count More To Unlock 
        //     let sraUnlockTextPIXIAPP = new PIXI.Text(rowConfig.Unlock.toString(), {
        //         fontFamily: 'NotoSansDisplay-Bold',
        //         fontSize: Scale.fh(110),
        //         fontWeight: 'bold',
        //         fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
        //         stroke: 'black',
        //         strokeThickness: Scale.fh(10),
        //         //wordWrap: true,			
        //         lineJoin: 'round',
        //         //textBaseline : "middle",			
        //     });
            
        //     sraUnlockTextPIXIAPP.anchor.set(0.5);            
        //     unclockContainer.addChild(sraUnlockTextPIXIAPP);           
        //     this.sraUnlockTextPIXIAPP.push(sraUnlockTextPIXIAPP);

            
        //     let sraTriggerContainer : PIXI.Container = new PIXI.Container();
        //     sraTriggerContainer.name = "sraTriggerContainer"
        //     sraTriggerContainer.position.set(Scale.W(492),Scale.W(169));
        //     rowUnlockviewPIXIAPP.addChild(sraTriggerContainer);
        //     sraTriggerContainer.scale.set(Scale.XY(0.8));
            
        //     let sraTriggerPIXIAPP : PIXI.Sprite = new PIXI.Sprite(sraTriggerTexturePIXIAPP);     
        //     sraTriggerPIXIAPP.width = leftSymbol.width;
        //     sraTriggerPIXIAPP.height = leftSymbol.height;             
        //     sraTriggerPIXIAPP.anchor.set(0.5);
        //     //sraTriggerPIXIAPP.position.set(Scale.W(353),Scale.W(169));
        //     sraTriggerContainer.addChild(sraTriggerPIXIAPP);
            

        //     let infoUnlockContainer : PIXI.Container = new PIXI.Container();
        //     infoUnlockContainer.name = "infoUnlockContainer";
        //     infoUnlockContainer.position.set(Scale.W(700),Scale.W(169));
        //     rowUnlockviewPIXIAPP.addChild(infoUnlockContainer);
        //     infoUnlockContainer.scale.set(Scale.XY(0.8))
        //     //Create Text More To Unlock 
        //     let textMoreTOUnclok =new PIXI.Text(this.translator.t.extendedSpinAndHoldInfoUnlock,{
        //         fontFamily: 'NotoSansDisplay-Bold',			
        //         fontSize: Scale.fh(85),			
        //         fontWeight: 'bold',
        //         fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
        //         stroke: 'black',
        //         strokeThickness: Scale.fh(10),			
        //         //wordWrap: true,			
        //         lineJoin: 'round',
        //         //textBaseline : "middle",			
        //     });
        //     //textMoreTOUnclok.anchor.set(0.5);
        //     //textMoreTOUnclok.position.set(Scale.W(670),Scale.W(169));
        //     infoUnlockContainer.addChild(textMoreTOUnclok);
        //     this.textInfoCanvasPIXIAPP.push(textMoreTOUnclok);

        //     //let button = new PIXI.NineSlicePlane(unlockFeatureFrameTexturePIXIAPP, 20, 20, 20, 20);

            
        // };

        //Add translator to info canvas 
        this.translator.SetOnLanguageChangedCallback(() =>
        {
            for (let index = 0; index < this.textInfoCanvasPIXIAPP.length; index++) {
                //this.SetStyleInfoCanvas(this.translator.t.extendedSpinAndHoldInfoUnlock, this.InfoCanvas[index] , this.fontHeightInfo)
                this.textInfoCanvasPIXIAPP[index].text = this.translator.t.extendedSpinAndHoldInfoUnlock                
            }
        });
        this.CreateAnim();
    }

    protected readonly symbolsByJackpot = {
        [JackpotDisplayType.RapidDiamondPot]: ["SRA"],
        [JackpotDisplayType.PlayCityLink]: ["SRA"],
        [JackpotDisplayType.RapidDiamondPotStep]: ["SRA"],
    }

    public async PrepareResources(resourceManager: IWriteOnlyResourceManager) {

        //new load PrepareResoruces decoded Image 
        resourceManager.AddGlobal(new DecodedImageResource(this.commonBonusResourcesBasePath + "resources/lock.png", ResourceIdentifier.Global.ScopedResourceName("sraLock")));        
        resourceManager.AddGlobal(new DecodedImageResource(this.commonBonusResourcesBasePath + "resources/UnlockFeatureFrameNinePatch.png",ResourceIdentifier.Global.ScopedResourceName("UnlockFeatureFrame")));
        this.audio.AddTrack(new Track(this.commonBonusResourcesBasePath + "resources/tracks/UnlockFeature" + Settings.audioFormat, this.resid.ScopedResourceName("unlockFeatureSound"))); 
    }

    public View(): HTMLElement
    {
        return null
    }

    // public ViewPIXIAPP(): PIXI.Container{
    //     return this.viewPIXIAPP
    // }

    public Show()
    {
       // this.view.style.visibility = "visible";
    }
    
    public Hide()
    {
        //this.view.style.visibility = "hidden";
    }

    protected prevResult: UnlockRowsResult = null;
    protected lastSaveRamaining : number [] = [];
    public UpdateSraUnlock(result: UnlockRowsResult)
    {     
        for (let i = 0; i < this.sraUnlockTextPIXIAPP.length && result.Rows.length; i++)
        {
            let remaining = this.config.Rows[i].Unlock - result.CountTotal;
            
            let prevRemaining = this.config.Rows[i].Unlock - (this.prevResult?.CountTotal ?? 0);

            // need to hide?
            if (remaining <= 0)
            {
                let notYetHidden = prevRemaining > 0;
                // Log.Debug("UnlockFeature", `Hide: ${i}, already hidden: ${!notYetHidden}`);

                if (notYetHidden)
                {
                    // TweenLite.fromTo(this.rowUnlockview[i], 1, 
                    //     { scale: 1} ,
                    //     { scale: 2, ease: "none", onStart: () => this.audio.Play(this.resid.ScopedResourceName("unlockFeatureSound"))}
                    // );


                    // TweenLite.fromTo(this.rowUnlockview[i], 1, 
                    //     { autoAlpha: 1}, 
                    //     { autoAlpha: 0, ease: Power3.easeOut }
                    // );

                    //gsap.to(this.rowUnlockviewPIXIAPP[i],{duration:1,scale:2});
                    let scale = { 
                        x : 1 ,
                        y : 1,
                        alpha : 1 
                    }
                    gsap.to(scale, {alpha:0, duration: 1, x:2 , y:2,onStart: () => this.audio.Play(this.resid.ScopedResourceName("unlockFeatureSound")) , onUpdate:()=>{
                        this.rowUnlockviewPIXIAPP[i].scale.set(scale.x,scale.y);
                        this.rowUnlockviewPIXIAPP[i].alpha = scale.alpha;

                    }});
                    //this.rowUnlockviewPIXIAPP[i].alpha = 0;
                }
                else
                {
                    // already hidden
                }
            }

            // need to update count
            else
            {
                if (remaining != prevRemaining)
                {
                    // Log.Debug("UnlockFeature", `Update: ${i} ${prevRemaining} => ${remaining}`);
                    //this.SetStyleInfoCanvas(remaining.toString(), this.sraUnlockMissingCanvas[i],this.fontHeightSra);
                    this.sraUnlockTextPIXIAPP[i].text = remaining.toString();
                    //this.lastSaveRamaining[i]=remaining;
                }
                else if (remaining == prevRemaining)
                {
                    //you hit more scra on base game , need upate . 
                    this.sraUnlockTextPIXIAPP[i].text = remaining.toString();
                }
            }
        }

        this.prevResult = result;
        
    }

    public Start(startConfig: UnlockRowsStartConfig)
    {           
        this.lastSaveRamaining = [];
       
        this.prevResult = startConfig;
    }

    protected PrepareRowsConfig()
    {
         for (let i = 0; i < this.config.Rows.length; i++)
        {
            let remaining = this.config.Rows[i].Unlock - this.prevResult.CountTotal;

            if (remaining <= 0)
            {                
                this.rowUnlockviewPIXIAPP[i].visible = false;
            }            
        }

        this.UpdateSraUnlock(this.prevResult);
    }

    protected CreateAnim()
    {
    }

    public StartAnim()
    {
    }

    public RestartAnim()
    {
    }

    public Update(){
        // for(let canvas of this.InfoCanvas){
        //     if(canvas.WasContextLost()){
        //         this.RedranCanvasInfo(canvas);
        //     }
        // }

        // for(let canvas of this.sraUnlockMissingCanvas){
        //     if(canvas.WasContextLost()){
        //         this.RedrawSraUnlock();
        //     }
        // }
        
    }   

    public CreatePIXIAPP(windowRectangle: Rect, symbolSize: Size) : PIXI.Container {
        this.rowUnlockviewPIXIAPP = [];
        this.sraUnlockTextPIXIAPP = [];
        this.textInfoCanvasPIXIAPP = [];

        this.viewPIXIAPP = new PIXI.Container();
        this.viewPIXIAPP.name = "unclockFeaturePIXIAPP";
        this.viewPIXIAPP.width = windowRectangle.width;
        this.viewPIXIAPP.height = windowRectangle.height;
        this.viewPIXIAPP.x = windowRectangle.x;
        this.viewPIXIAPP.y = windowRectangle.y;

        for (let rowIndex = 0; rowIndex < this.config.Rows.length; rowIndex++) {
            let rowConfig = this.config.Rows[rowIndex];
            let leftSymbol = symbolSize;
            //let totalWidth = this.spinnableReels2.GetWindowSize().width;

            //rowUnlockviewPIXIAPP main container 
            let rowUnlockviewPIXIAPP : PIXI.Container = new PIXI.Container();
            rowUnlockviewPIXIAPP.width = windowRectangle.width;
            rowUnlockviewPIXIAPP.height = leftSymbol.Height;
            //rowUnlockviewPIXIAPP.y = leftSymbol.height * rowIndex;
            rowUnlockviewPIXIAPP.name = `unclokRow-${rowIndex}`;            
            this.viewPIXIAPP.addChild(rowUnlockviewPIXIAPP);
            this.rowUnlockviewPIXIAPP.push(rowUnlockviewPIXIAPP);
            
            //texture black for alphanel main container
            // let rowUnlockviewPIXIAPPTEXTURE : PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
            // rowUnlockviewPIXIAPPTEXTURE.width = this.windowRectangle.width ;
            // rowUnlockviewPIXIAPPTEXTURE.height = leftSymbol.height;PI
            // rowUnlockviewPIXIAPP.addChild(rowUnlockviewPIXIAPPTEXTURE);            
            // rowUnlockviewPIXIAPPTEXTURE.tint = 0x000000;
            // rowUnlockviewPIXIAPPTEXTURE.alpha = 0.8;


            let unlockFeatureFrameSprite = new PIXI.NineSlicePlane(this.unlockFeatureFrameTexturePIXIAPP,1,1,1,1);            
            unlockFeatureFrameSprite.name = "unlockFeatureFrameSprite";
            unlockFeatureFrameSprite.width = windowRectangle.width;
            unlockFeatureFrameSprite.height = leftSymbol.Height;
            rowUnlockviewPIXIAPP.addChild(unlockFeatureFrameSprite);


            let unclockContainer : PIXI.Container = new PIXI.Container();
            unclockContainer.name = "unclockContainer"
            unclockContainer.position.set(Scale.W(180),Scale.W(169));
            //unclockContainer.scale.set(Scale.XY(1));
            rowUnlockviewPIXIAPP.addChild(unclockContainer);

            let sraLockSpritePIXIAPP : PIXI.Sprite = new PIXI.Sprite(this.sraLockTexturePIXIAPP);     
            sraLockSpritePIXIAPP.anchor.set(0.5); 
            sraLockSpritePIXIAPP.scale.set(Scale.XY(0.8));      
            unclockContainer.addChild(sraLockSpritePIXIAPP);

            //Create Count More To Unlock 
            let sraUnlockTextPIXIAPP = new PIXI.Text(rowConfig.Unlock.toString(), {
                fontFamily: 'NotoSansDisplay-Bold',
                fontSize: Scale.fh(115),
                fontWeight: 'bold',
                fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
                stroke: 'black',
                strokeThickness: Scale.fh(10),
                //wordWrap: true,			
                lineJoin: 'round',
                //textBaseline : "middle",			
            });
            
            sraUnlockTextPIXIAPP.anchor.set(0.5);            
            unclockContainer.addChild(sraUnlockTextPIXIAPP);           
            this.sraUnlockTextPIXIAPP.push(sraUnlockTextPIXIAPP);

            
            let sraTriggerContainer : PIXI.Container = new PIXI.Container();
            sraTriggerContainer.name = "sraTriggerContainer"
            sraTriggerContainer.position.set(Scale.W(492),Scale.W(159.5));
            rowUnlockviewPIXIAPP.addChild(sraTriggerContainer);
           // sraTriggerContainer.scale.set(Scale.XY(1));
            
            let sraTriggerPIXIAPP : PIXI.Sprite = new PIXI.Sprite(this.sraTriggerTexturePIXIAPP);    
            
            
            let scaleWidth = symbolSize.Width / sraTriggerPIXIAPP.width;
            let scaleHeight = symbolSize.Height / sraTriggerPIXIAPP.height
            let scale = Math.min(scaleWidth, scaleHeight);
            sraTriggerPIXIAPP.width = sraTriggerPIXIAPP.width * scale;
            sraTriggerPIXIAPP.height = sraTriggerPIXIAPP.height * scale * this.aspectFixY;
            sraTriggerPIXIAPP.anchor.set(0.5);
            //sraTriggerPIXIAPP.position.set(Scale.W(353),Scale.W(169));
            sraTriggerContainer.addChild(sraTriggerPIXIAPP);
            

            let infoUnlockContainer : PIXI.Container = new PIXI.Container();
            infoUnlockContainer.name = "infoUnlockContainer";
            infoUnlockContainer.position.set(Scale.W(700),Scale.W(169));
            rowUnlockviewPIXIAPP.addChild(infoUnlockContainer);
            //infoUnlockContainer.scale.set(Scale.XY(1))
            //Create Text More To Unlock 
            let textMoreTOUnclok =new PIXI.Text(this.translator.t.extendedSpinAndHoldInfoUnlock,{
                fontFamily: 'NotoSansDisplay-Bold',			
                fontSize: Scale.fh(75),			
                fontWeight: 'bold',
                fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
                stroke: 'black',
                strokeThickness: Scale.fh(10),			
                //wordWrap: true,			
                lineJoin: 'round',
                //textBaseline : "middle",			
            });
            //textMoreTOUnclok.anchor.set(0.5);
            //textMoreTOUnclok.position.set(Scale.W(670),Scale.W(169));
            infoUnlockContainer.addChild(textMoreTOUnclok);
            this.textInfoCanvasPIXIAPP.push(textMoreTOUnclok);      
            rowUnlockviewPIXIAPP.pivot.set(rowUnlockviewPIXIAPP.width/2,rowUnlockviewPIXIAPP.height/2);
            rowUnlockviewPIXIAPP.position.set(rowUnlockviewPIXIAPP.width/2,rowUnlockviewPIXIAPP.height/2 + (leftSymbol.Height * rowIndex));               
          
        };

        this.PrepareRowsConfig();
        return this.viewPIXIAPP;
    }
}
